import { usermanager as http } from "@/http";
import usersMock from '@/modules/users-manager/__mocks__/users-mock.json';

const API_URL = '/users';
const isLocal = () => window.__env?.back_end?.enviroment === 'local';

class UserService {
    async getUsers(params) {
        if (isLocal()) {
            const page = params.page ?? 0;
            const size = params.size ?? 10;
            const offset = page * size;
            const sliced = usersMock.data.slice(offset, offset + size);
            return {
                data: {
                    pages: Math.ceil(usersMock.data.length / size),
                    currentPage: page,
                    elements: sliced.length,
                    totalElements: usersMock.data.length,
                    data: sliced,
                }
            };
        }
        return await http.get(API_URL, { params });
    }
    async updateUserRole(userid, user) {
        if (isLocal()) {
            const target = usersMock.data.find(u => u.cassiopeaUserId === String(userid));
            if (target) target.role = user.role;
            return { cassiopeaUserId: userid, role: user.role };
        }
        const body = { role: user["role"] }
        const response = await http.put(`${API_URL}/${userid}/role`, body);
        return response.data;
    }
}

export default new UserService();
